module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title28"
    }
  }), _c('div', {
    staticClass: "title-chapter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("B")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title29"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Babbitt")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The main character in Sinclair Lewis’s novel of the same name. He is shown as a simple likeable fellow with faint aspirations to culture that are smothered in the crude all enveloping activities of earning a living and “keeping up” with the Joneses. In this sense the term Babbitt has become synonymous with the typical American business man engrossed only with money-making schemes, unconcerned with any of the artistic or cultural activities of his community unless they in some way lead to financial contacts.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title30"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Babe, the Blue Ox")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The legends about Paul Bunyan contain a great deal about his companion and chief assistant in his logging operations, Babe, who was of enormous size and had a tremendous appetite. In fact, he met his death by eating a great quantity of hot cakes, stove and all. Babe was so heavy that his footsteps formed the lakes of Michigan and of Oregon.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title31"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Baby’s first lock of hair")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("It was not sentiment alone that started the practice of preserving the first lock of hair cut from the new baby’s head but an old superstition that if this hair were preserved in a safe place the child would live to a ripe old age. There was an idea also that if the child’s hair were cut as he grew up it would adversely affect his eyesight; therefore both boys and girls were decorated with long curls.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title32"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("baby removed from dead mother")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This theme is common among many of the Indian tales from the Atlantic to the Pacific, though the Plains area is especially associated with them. In a Shoshone story, “The Wolf and the Geese,” two such women are involved and a baby girl is taken from one and a boy from the other. The girl can immediately walk and travels about with the Wolf.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title33"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bachelor buttons")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This term might be used for any type of flower with button-shaped head like a corn flower. A lovelorn young man would carry one in his pocket to discover his future state; if it lived he would marry his sweetheart, but if it died he would have to find another.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title34"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("backstone (attually back hearthstone)")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A raised section of the hearth formed a sort of partial ledge that was built across the back of the hearth in the colonial period. The two sides of the fireplace acted as natural reflectors of heat to this spot and here pies, bread and tarts were put to bake. Later the backstone was a large iron disk ever so slightly dished out, either suspended from the crane or supported on a spider.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title35"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("backward action")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Performing a normal action backward may cause a person to acquire magic power. On the other hand to change some article of clothing put on backwards may bring bad luck. Flying a flag upside down is an accepted symbol of distress.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title36"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bacon and . greens")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("In parts of Virginia they claim that the eating of bacon and greens is required for the making of a Virginian.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title37"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bad dress rehearsal—good opening")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A Broadway proverb that is part of the body of stage folklore.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title38"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("badger")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The Hopi and other Pueblo Indians look upon the badger as having special curative power since he is associated with the digging up of roots and plants. His paw is kept near a woman in childbirth in an attempt to encourage a speedy delivery since a badger can dig himself out quickly. His tooth is held to be a good cure for toothache.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title39"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("badgers")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This was a name for the miners who stayed all season in Wisconsin in the lead mines around Hardscrabble and New Diggings. The badgers with their stamina to stay all the year around were more admired than the miners who went south in the fall and this was part of the reason for naming Wisconsin the Badger State.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title40"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bad man")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The “Bad Man” in American folklore may be traced to the wave of banditry following the Mexican War and to the continuation of some of the guerilla activities of some of the units that were active during the Civil War. The wars between the cattlemen and the sheepmen also encouraged the rise of such lawless individuals who took action into their own hands. With many colorful figures involved the average man tended to look upon the “good” bad man with considerable respect. In this category would be classed Jesse James, Sam Bass, and Pretty Boy Floyd, especially since each was killed finally largely through treachery. Others of the killer class would have no less popular appeal with the accounts of their viciousness growing with the telling. Billy the Kid claimed he killed twenty-one and ten of them single handed.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title41"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Balaam’s basket")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A term used by printers to refer to a receptacle containing stereotyped bits of information used by them to fill up small spaces left vacant on the page being set up in a newspaper.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title42"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("balance and swing")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("An American square dance term which calls for the gentleman to swing the lady completely around him once or twice.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title43"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ballast for fish")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("White Pine Tom told great tales in the Michigan lumber camps. One winter he was selling fish to such a camp. He had loaded them with sand to make them weigh more. Finally this trick was discovered and the cook challenged him to explain his seeming cheating. Tom was not stumped at all. He explained that Lake Michigan was so deep that the fish ate sand in order to take on ballast and get to the bottom of the lake where the feeding was good.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title44"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ball the Jack")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A dance originated by American Negroes which is accompanied by handclapping and chanting. A “highball” in railroad slang meant to go ahead fast and the jack was the locomotive. The refrain would be, “And I ball the jack on the railroad track” while there would also be a rolling movement of the hips of the singer.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title45"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“balloon lines”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Rudolph Dirks, one of the earliest creators of comics had originated the “Katzenjammer Kids.” After his first few experiments he introduced speeches for his characters which he wrote above or near the speaker and encircled with a line drawing forever afterwards known as a balloon.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title46"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bals du Roi (Kings’ Balls)")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Kings’ Balls were held in New Orleans on Twelfth Night, January Sixth. An elaborate cake was always served as a crowning part of the festivities. The finder of the bean in the cake was designated host or hostess at the next celebration. This custom begun long ago still continues. After this opening celebration there are a whole series of balls until the culminating activities of the Mardi Gras on Shrove Tuesday the day before Lent begins. There is one other great ball in the midst of Lent the mi-careme, or St. Joseph’s night on March 19th.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title47"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Baltimore, gastronomic center of the world")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Oliver Wendell Holmes is supposed to have coined this phrase after having dined at the home of Mrs. Du Bois Egerton on Madison Street where all the delicacies for which Baltimore was justly famous were served, such as, canvasback duck, terrapin, an oyster roast or chicken a la Maryland.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title48"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bandanna")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The cowboy would indeed have been lost without his essential bandanna. He used it at the water hole for a towel. He tied it around his neck to make a neat appearance at breakfast. Later he might use it to blindfold his horse while he mounted. Perhaps he wanted to put a calf to one side for branding, he would use his bandanna for a “pigging string” to hold its feet. He had protection from the sun for the back of his neck, or for his face as need arose, or he could use it as a mask if the day was dusty, or as a shield if in a blizzard. It mopped the sweat away, or saved his hand from hot handles. He could drink from it in necessity or make a sling of it, or finally be buried in it.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title49"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("band wagon, to get on")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("It was the custom in early election days to carry the band along on a wagon during the pre-election campaigning. Local political leaders desirous of showing their support of the candidate for whom the parade was being staged might jump up on the wagon to make a few remarks in his favor between selections or while passing from one town to another, thus the expression came to be applied to any action where the public went along with a popular program or to designate approval.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title50"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bang-All")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The famous gun of the redoubtable Mike Fink. So skillful was he in the use of it that he was eventually excluded from all contests.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title51"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("banjo")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A musical instrument resembling a guitar; it was brought to the United States by the Negro slaves from West Africa and became popular as an accompaniment for singing and dancing. It was held to be an instrument of the devil by pious people who thought its use kept the frivolous ones out of the churches and led them to evil ways. When minstrel shows became widespread a five-string banjo was used for the rippling, strongly rhythmic music, soon known and loved all over the United States. “Old Dan Tucker” was a favorite piece for the banjo picker. Some of the tunes were carried over for square dancing and the words often combined ballad-type material covering any subject from wooden legs to mine disasters.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title52"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bank barns")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The tremendous barns built by the Pennsylvania Dutch became a standard for such buildings in America. They were often sixty feet long by forty feet wide and sometimes as long as one hundred feet made with an inclined approach or ramp that made it possible for wagons to drive into the upper level. Here were the great threshing floors with lofty mows rising on both sides. The basement was used as a stable for horses and cattle with further passages closed by divided or “Dutch” doors.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title53"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("barber’s cat")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Sea slang for a talkative messmate.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title54"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("barber shop mugs")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("These china and clay mugs had a tremendous vogue from the 1880’s on and could be ordered from large catalogues in an enormous quantity of styles or materials. They were often decorated to indicate the occupation of the individual for whom they were kept on the shelf in the barber shop. Sometimes a chaste and simple design was employed but often gold lettering and elaborate coloring were used. Hundreds of emblems were available as choices to fit the individual desire.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title55"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("barnstormer")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A ham (amateur) actor on tour. Also used for the early airmen putting on flying demonstrations after World War I.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title56"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("barrel house")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A term used for a cheap saloon about 1900 where the barrel of liquor was freely accessible to the drinkers and where an early type of jazz developed.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title57"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("barrel treatment for drunkenness")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("At Fort Snelling the commandant tried to keep his troops from drinking or selling liquor to the Indians as steam boats began to ply the Mississippi about the 1830’s. As punishment he walked the guilty ones up and down under guard bearing the statement, “I was drunk last night.” In this small post he once had forty-seven of the garrison in the guard house for this offense.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title58"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("barrenness")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This was a condition for which American folklore offered many charms or treatments for its correction.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title59"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Barricke Mariche")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A legend in Berks County recalls that a German family of four women found life uncomfortable in Germantown during the Revolutionary War and so left for the Oley Hills of Pennsylvania where they were forced to endure a hard life farming. At last Mary alone was left alive, but continued to do the difficult job of making a living for herself by working the farm alone for thirty years until she was seventy-five. She was tender-hearted and did much good in the neighborhood despite her inaccessible position. A marker on her mountain road states:\n")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-indent-inverse-blocktext"
  }, [_vm._v("“A pioneer nurse, comforter of body and soul, benevolent, pious, brave and charitable")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent-inverse-blocktext"
  }, [_vm._v("She hath done what she could” died 1819.")])]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title60"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bartholomew baby")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The term doll did not come into use until the Eighteenth Century but a child’s plaything that was an elaborate forerunner of dolls was known as a Bartholomew baby. Images made in the shape of human beings were sold in great quantities at the Saint Bartholomew Fairs held in London. Some of the figures were elaborately dressed and were used to convey fashion news as illustrations are used today. The Puritans tried to stop the Fairs while they were in power and to discourage the “babies” from being popular but they were quite unsuccessful. Later the term Bartholomew doll did come into usage, but it was used to refer to a tawdry, overdressed woman who might resemble those who attended the fair rather than the figures that were sold there.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title61"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("basers")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A certain style of singing American Negro spirituals developed in which these “basers” rendered the response following a narrative line sung by the leader. They were usually so quick to respond that an impression of continual singing was given.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title62"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Basin Street")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This was a street in the French Quarter of New Orleans in a notorious Red light district where a special type of musical composition was first experimented with and now is looked upon with nostalgia by some as the birth place of jazz.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title63"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bathing beauties")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A man had built some gorgeous Roman Baths at Miami Beach in the 1920’s. His wife while taking swimming lessons wore a one piece bathing suit which caused a minister to condemn her action. The resultant publicity was claimed as sufficient to develop the idea of “bathing beauties” to advertise such beauty spots.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title64"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Battalion Day")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Among the Pennsylvania Dutch this was a day celebrated upon Whitsunday until nearly 1900. The local volunteer militia was mustered out after having held a review and parade. When the men could afford gay uniforms it was a colorful and largely-attended program.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title65"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Battle-ax beliefs (Pennsylvania)")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A group led by Theophilis Gates introduced a novel and amazingly modern set of beliefs, but astonishing to the straight and narrow Philadelphians who first heard of them. He argued for a religion which would not bind him forever to his wife, but neither did he want one which would tolerate free love or promiscuity. He developed, therefore, the creed of the Battle Ax. Marriage was not intended to be permanent. Men and women should change their partners if they could not live in peace and harmony. Other converts joined their faith, which gradually began to assume other curious customs. Opposition developed of course, but the Battle Ax followers had an infallible method of silencing most pastoral criticism. After just having participated in one of their own services a Battle Ax member marched naked up the aisle of the church of a speechless clergyman who silently departed from his church.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title66"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bayberry candles")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Burn one on Christmas Day. If the flame burns bright and the light shines clear, then heaven will bless you all the year. To prepare the candles the directions were to boil great quantities of the berries in water. Upon cooling the wax coating of the berries which had been melted off would have formed a crustlike gray-green ice upon the surface of the water. This crust was removed and remelted in deep pans. A candle wick was dipped into the melted wax and then redipped each time as a layer hardened and the process was continued until the desired size was attained. Material for wicks was in short supply during the colonial period. Molds were later used made of a great variety of substances such as glass, pottery, china, stone wear, tin, pewter, iron and wood. Candle sticks were made of any of these materials and anything else the individual might think of such as whale bone or cattle horn, too.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title67"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bayou State")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The state of Mississippi has won this designation because of its many creeks, or marshy overflows of rivers and lakes.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title68"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bear-hunting, Ozark style")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("When you fire at the bear, injure him but do not cripple him, he will then be so angry that he will chase you all the way home and save you the trouble of packing the meat home yourself.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title69"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“bear traps”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The river near Mauch Chunk, Pennsylvania in the early mining days sometimes ran very low. After a severe drought in 1818 artificial means of making the stream navigable had to be developed. A sluice gate provided artificial freshets. These arrangements are very curious looking and when questions were asked as to the purpose intended for them the first responses were that they were intended to catch bears. The term “bear trap” stuck for a long time afterwards. There is a street in Mauch Chunk still called Trap Alley after these units.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title70"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bearwalkers")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The Indians in the Michigan peninsula believe that there is a force or power for evil that may haunt the neighborhood. They call this strange force a bearwalk and they try to kill it before it can kill them. It has no power over a white person. It may try to put a person to sleep or take the shape of any animal in order to attack an enemy.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A person can catch a bearwalk with the right medicine and have its power transferred to him. Shooting will do no good for then he will go off and the person after the bearwalk will get no benefit. Most people fall over in a faint when they see a bearwalk but those who are able to withstand it will live much longer than those who faint.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title71"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("beats my time")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A western expression meaning to do better than some one, or more especially to win the right to call upon a young lady.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title72"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("beaver")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Beavers have musk-producing glands which secrete a substance almost as valuable as their skins themselves and which the superstitious claim are valuable for the curing of toothache and a number of other ailments. The common belief in the great activity of the beaver as shown in the popular expression, “as busy as a beaver” is more folklore than scientific fact.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The interpretations of the beaver’s activities for weather prediction is not any more dependable though there are those who maintain if he stores up a large supply of food that means a long, hard winter, and that if his coat is heavy that indicates the same possibility.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title73"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bed-rock, to be down to")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Slang for being down to one’s last dollar. Also used by miners to indicate that they have reached the bottom of the vein that will produce any more “pay dirt” or ore of any real value.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title74"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bed superstitions")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("So widespread has been the belief in the bad luck resulting from getting out-of-bed on the left side that it is common to refer to a person who is cross as having gotten out of bed on the wrong side. To the ancients the left or sinister side was likely to bring danger under any circumstances. In this case his remedy was to go back to bed, backwards to reverse the effect of the action and then get up again the right way, that is on the right side.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title75"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bee")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Mississippi Negroes believed that to have a swarm of bees come to you of their own accord was sure to bring bad luck. Even to dream of a swarm alighting on a building portends misfortune. There is also a superstition that dead bees burned to ashes and sprinkled in the shoes will cure flat feet.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("It is probably unwise to count on one other belief about bees that they will not sting a person if he holds his breath, clenches his fist or otherwise produces a tension.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title76"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Beecher’s Bibles")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This term was used for the “aid” sent by the abolitionists to help those trying to keep slavery out of Kansas in the bitter period when the Kansas-Nebraska Act had opened the territory to the principle of popular sovereignty or the vote of the people. The Reverend Henry Ward Beecher was an ardent Abolitionist, pastor of the Plymouth Church in Brooklyn. He heard of the assistance various groups in Connecticut were trying to render to those opposed to slavery in Kansas and he helped to raise funds for this purpose. Two articles it was felt were particularly needed—rifles and Bibles, so both were shipped in together in boxes labeled “Bibles.” The Sharp’s rifles or carbines were the “Beecher Bibles.”")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title77"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("beeswax candles")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A children’s service on Christmas Eve in the Moravian churches is usually concluded by a candle light service. In Bethlehem, Pennsylvania, everyone carefully preserves the remainder of the candle used at this time for it was especially prepared as a symbol of the Christmas season.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title78"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("belaying-pin soup")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The rough treatment, or threat of such extended to merchant seamen by bullying mates in a sailing vessel. The belaying-pin could make a formidable weapon if it reached its goal.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title79"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“Bell don’t make bump”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Because many of the Pennsylvania Dutch had led a somewhat isolated existence the older folk did not often speak English. However when they did learn they developed some amusing corruptions as in the case here where the intention is to say that the bell does not ring.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title80"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bells of Conestoga wagons")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Five of the six horses that pulled a huge Conestoga wagon had a bow of four bells across their backs. These were worn for more than their attractive chimes since it was very useful to have it known far in advance that this heavy and lumbering vehicle was on its way. Each driver took great pride in his bells the possession of which indicated his ability to take care of himself successfully. If stuck in a mud hole or some such difficulty and forced to appeal for help his bells were the price he had to pay for any help, for it was understood that to the rescuer went the bells of the rescued wagon. This was a severe humiliation for a tough driver to accept. From this wearing of the bells arose the expression “to be there with bells on,” that is to be on the Lancaster Pike, where the Conestogas ran, ready to advance.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title81"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Belsnickel")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The Pennsylvania Dutch borrowed a custom from Holland and the Rhineland where there was a figure the opposite of Saint Nicholas. He was a Nicholas in fur. A neighborhood boy might dress in a shaggy bearskin coat and cap and visit the children who lived in the vicinity. Over his shoulder he would carry a bag with switches sticking out. When admitted to the kitchen he might tap the window with a switch to let the naughty children know what they might have in store for them, but if the children were found to have been good the floor was strewn with candies and nuts from his bag. The Belsnickel no longer makes these visits for he frightened the children so he was not felt to be in keeping with the Christmas spirit.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title82"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ben Delimus")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Ben became an almost legendary figure in Alabama after the Civil War. Upon his discharge from the Northern army he went back to Alabama whose fertile soil he had particularly taken note of during his campaigning. There he played upon the gullibility of the new freemen. He appealed to them as a close friend of Lincoln and Grant and warned them that the baptisms made while they were slaves would not be adequate. For a dollar he rebaptized all those who came to him. When he had exhausted the possibilities of this “racket” he claimed that they had to be remarried also. When he had milked this situation dry too, he began to market a liquid to take the curl out of Negroes’ hair for which he charged a dollar a bottle and prospered greatly.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Seeking new fields to conquer he decided to run for political office. At the nominating convention he contrived to put the other candidates at a disadvantage by opening the convention with a prayer that was really a political harangue. Supposedly his opponents could stand it no longer and one interrupted crying, “Who is this who dares to condemn us? He is the one who crucified the Lord.” The Negro audience was aghast and Ben could feel them turning against him. He then cried “I could not have done that. It happened over two thousand years ago and I am not that old; and in addition I would have stopped it if I had been there.” He won the election and remained a strong influence in the community for many years afterwards.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title83"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“best wore out”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A French Canadian expression meaning that something has been well broken in as shoes or harness or something of that type.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title84"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bet-A-Million Gates")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("John W. Gates was a well-known betting man at the turn of the century and the situation involving the famous Coal Strike of 1902 looked like a sure thing to him. He said he would pay odds of 1000 to one that the miners would give in. However as cold weather approached pressure became so great on the operators and Mitchell the organizer of the strike was so firm in his demands Gates lost out on his great gamble.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title85"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("betsy lamp")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("One of the earliest and crudest means of illuminating the colonial homes was this type of lamp which was really only a saucer or shallow vessel with a spout which burned grease.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title86"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bezoars")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Stones found in the stomach, liver or intestines of some animals, but particularly the deer, possess magical properties in the eyes of their Indian finders. The stones often attained large monetary exchange value because of the intense interest with which they were sought by many.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title87"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bibliomancy")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Divination by means of books, but more particularly by means of the Bible. Where the Bible in pioneer households was often the only book besides an Almanac in the house considerable store was set by the practice of opening the Bible at any random spot in order to obtain an answer to some question being asked at that time. A somewhat oracular quality was given to the practice by the means employed to interpret the appropriate verse to meet the situation involved. Cliodomancy was a somewhat related practice in which a hanging key was used, the swinging movements of the latter requiring interpretation.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title88"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Big Owl")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The Apache Indians believed in an evil creature who would come to eat them up but from whom they would be rescued when one of their heroes would kill him before he could place them in his basket to be carried home and eaten.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title89"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“Big Runaway”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The flight from the Tories in 1778 down the North Branch of the Susquehanna from the Wyoming Valley near present day Wilkes-Barre was such a wild rush it has been given this colorful title. Hundreds fled on boats, canoes, rafts, on anything that would float, in wild distress fearing the ruthless attack of the Indian allies of the British. The men marched single file on each side of the river to try to guard the women and children on the water. Often the women had to leap out of their boats to push them past some obstruction. The hastily loaded boats carried tables, spinning wheels, bedsteads, kettles and cows. Their occupants in some cases just barely made their escape. One woman who actually lost her scalp lived seventy years thereafter.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title90"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Big Sea Day")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A colorful outing celebrated on the Jersey coast on the second Saturday in August for many years until the shore was preempted for more distant vacationists. Whole families were loaded on the wagons and drove out to the sea from the pine woods area of southern Jersey. Everyone went bathing in whatever clothes they had on that day and stood around and dried off in the sun. There were some who tended to call this day, “Farmer’s Wash Day” because of this aspect of the celebration. For those who for various reasons were unable to attend on the second Saturday, at Sea Girt, there was a Little Sea Day celebration, on the third Saturday in August.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title91"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Billy the Kid")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("From the brief outline of the facts of the life of William Bonney, Billy the Kid born 1859 a strange collection of stories has developed. In the eyes of many the legend about him has grown to heroic size and does not seem likely to diminish with the cult of the bad man still going strong. Strangely two almost exactly opposed views of him can be easily put together. To the Mexicans he seemed friendly and helpful. They found him so brave and handsome and generous. Even after he had begun his killings nothing seemed to weigh on his cheerful nature, said some reports. On the other hand his one authentic picture shows a “nondescript, adenoidal, weasel-eyed, narrow-chested, stoop-shouldered, repulsive-looking creature.” Just the same stories of his activities grew through the years though the accounts of his twenty-one killings in his twenty-one years seem highly exaggerated. Though supposedly shot in the dark by Sheriff Pat Garrett there were even in 1929 still rumors that he was hiding out in Texas.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title92"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Binghamton’s Origin")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("In 1785 the Indians gave up their claim to Ochenana, a place of seven hills where the little Chenango river joins the wide Susquehanna. The next year a Philadelphia merchant William Binghamton bought this area and with his friend Joshua Whitney organized a chopping bee to clear his Chenango Point land. He planned to give this land to form a community for “a quiet and industrious people who may give a good reputation to the neighborhood as well from their skills as from their orderly moral conduct.” These new citizens were so appreciative they named the town in his honor.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title93"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bird in the house")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("In Alabama for a bird to fly into the house was considered a sign of good luck. Other areas look upon it with favor if a bird builds its nest in the house. Yet it is claimed that wall paper does not have bird designs because some people think it will cause luck to fly out the window. A bird tapping on the window of the house was believed to be a bad omen on the assumption that the bird’s soul was inviting another soul to join him meaning that there was going to be a death in the household.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title94"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bird lore")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("See:")]), _vm._v(" B"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("UZZARD")]), _vm._v(", B"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("LUEJAY")]), _vm._v(", C"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ANARY")]), _vm._v(", O"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WL")]), _vm._v(", P"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("EACOCK")]), _vm._v(", P"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("IGEON")]), _vm._v(", R"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("OBIN")]), _vm._v(", W"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("HIPPOORWILL")]), _vm._v(", S"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("EA")]), _vm._v(" G"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ULL")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title95"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Birthday folklore")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A popular rhyme about this subject states:\n")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-br-blocktext"
  }, [_vm._v("Monday’s child is fair of face "), _c('br'), _vm._v("Tuesday’s child is full of grace "), _c('br'), _vm._v("Wednesday’s child is sour and sad "), _c('br'), _vm._v("Thursday’s child is merry and glad "), _c('br'), _vm._v("Friday’s child is loving and giving "), _c('br'), _vm._v("Saturday’s child must work for a living "), _c('br'), _vm._v("While the child that is born on the Sabbath Day "), _c('br'), _vm._v("Is blithe and bonny and good and gay.")])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Another popular belief associated with birthdays has to do with the spanking usually administered at that time.")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-br-blocktext"
  }, [_vm._v("One to grow on "), _c('br'), _vm._v("One to live on "), _c('br'), _vm._v("One to eat on "), _c('br'), _vm._v("One to get married on.")]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_vm._v("These are usually considered extras in addition to the one for each year of the person’s age. Blowing out the candles on one’s birthday cake has a number of interpretations. One version claims you get your wish if you blow them all out.")])]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title96"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("birthday superstitions")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Old wives’ tales have provided a large quantity of beliefs surprisingly many of which are still in current acceptance. It was said that a woman lost a tooth for every child she bore. It was falsely claimed that she could not conceive while she continued to nurse the new baby. Notions that prenatal influences may have a bearing so as to leave a mark upon the child are of very old duration. To be born with a caul has had many superstitions associated with it. They say if the caul is red the child will have prophetic insight, if blackish, misfortune will follow. The possession of a caul was very valuable to a sailor who then could expect a safe voyage, so that the midwives did quite a business in surreptitiously putting them aside for future business.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title97"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Biscaino, Don Pedro")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A Basque adventurer who settled on the Florida keys near Miami-to-be from whom was derived the name Biscayne Bay.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title98"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("black birding")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("An expression used to describe the practice of secretly picking up African tribesmen and bringing them to the South as slaves.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title99"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“black cat”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A term used by the fishermen and sailors on Lake Superior for a boat that has had a spell cast on it and which can never get a full crew to come aboard.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title100"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“black grains”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("When Philadelphia was about to be attacked in 1745 even the Quaker pacifists could not completely overlook the danger to the colony of the possible attacks by French or Spanish privateers. They therefore voted an appropriation of four thousand pounds to be expended in the purchase of bread, meat and grain for the city. It was then liberally, and deliberately, interpreted that “black grains” (gunpowder) were to be included.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title101"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Black Hawk")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This chieftain was hated and reviled by the people of the Upper Mississippi while the Black Hawk War was raging. Young Abraham Lincoln led a force against him. This much-surprised chieftain found himself well treated after his capture. He was taken to Washington with much honor. “Black Hawk could not understand the ways of American generals who were sent against him.” Havinghurst.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title102"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“Black legs”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A term used for fastidious gentlemen dwelling in Mississippi and Louisiana in the 1880’s. Well groomed and elegant, though quietly dressed, they abhorred temperance, favored racing and cock-fighting. On occasions they acted as “chaperons” for wealthy young men whom they would take on trips on the Mississippi steamboats, at which time they might quite legitimately relieve them of their surplus cash in little gambling matches.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title103"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“Black Robes”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("In 1831 a delegation of four Indians, probably Nez Percés or Flat heads, reached St. Louis seeking a Black Robe, a Roman Catholic priest, whom they had heard about from some Canadians in the upper Missouri area where they lived. Protestant missionaries heard of the “call” and went out to satisfy the request. But the story goes that the Indians would have none of them since the Protestants had wives and did not wear crosses or offer the “Big Prayer” in which they were interested. A Jesuit father, Pierre de Smet, eventually reached the area and became well-beloved in his ministration to the Indians from 1837 to 1867. He was later instrumental in arranging a peace treaty with them, the “Treaty of Laramie.”")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title104"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("blood beliefs")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Blood was held to be in every sense a life-giving substance so that if you wanted to dispose of evil creatures you tried to get a drop of the blood to work with. In reverse some of the Indians drained all the blood out of the animals, they were going to eat so that none of the animal spirits would enter into them. The drinking of blood was looked upon as being equal to a transfusion. The superstition that a dead body bleeds in the presence of his murderer has long been held. The covenant of blood brothership in which the participants exchange a drop of blood in various ceremonial rituals indicated the high regard in which blood was held and also a feeling for its magical properties. That “Negro” blood was different from that of a white person has been one of the most deeply ingrained of the racial prejudices. Allied to this were the beliefs that considered the possibility of “bad” blood transmitting criminal or physical characteristics.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title105"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bloviating")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("President Harding recognized that he belonged to the old school of political haranguers and used this term to describe his rather bombastic kind of speech-making. Others were less kind and called him sententious and meaningless.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title106"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“Blow Gabriel Blow”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("In a small town on the Eastern shore of the Chesapeake Bay a famous Methodist preacher was supposed to have produced considerable consternation among a large number of his followers who were listening to him in an overflow meeting in the church yard. After much exhortation he started describing the angel Gabriel with a silver trumpet in his hand, and then by prearrangement, (he had met a small colored boy on his way to the meeting trudging along with a horn in his hand,) the lad had blown his horn when the preacher had cried “Blow Gabriel Blow.” The congregation fell to the ground crying for mercy at this too literal answering of a prayer. When the trick was discovered the people were annoyed but the preacher warned them if a small boy could scare them that much what terror would there be in their hearts when Judgment Day really came! The tale lost nothing in the numerous retellings to which it was subjected.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title107"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("blow the grampus")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("An old Merchant Navy term for pouring water over a sleeping sailor to bring him to in a hurry.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title108"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("blue-eyed boy")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("One who enjoys special favors in the business world or the armed forces. “Fair-haired boy” is an equivalent expression.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title109"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Blue Hen’s Chickens")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Raising a regiment in the early days of the Revolution Captain Jonathan Caldwell’s Delawareans brought with them two game cocks hatched from the eggs of a small steel blue hen. In honor of the two birds who could outfight any others with which they were matched, the men from Delaware when they marched off to battle called themselves the sons of the Blue Hen, game to the last. In time they changed it to the Blue Hen’s chickens which title the troops from Delaware have proudly borne ever since.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title110"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Blue Hill Hermit")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("John Mason desired to flee from all contact with women so he built a strange octagonal tower near Sunbury, Pennsylvania which according to some leaned as much as thirty-five degrees. Here he lived alone for many years known as the Blue Hill hermit. When the Susquehanna froze over he would skate to Harrisburg always carrying an umbrella. He was ultimately buried by a deep precipice near his tower.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title111"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bluejay")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The bluejay is personified in the trickster category by the Indians. The Apache particularly tell a long cycle of tales showing him as a hero anxious to outdo his rivals. The bluejay also has the power to direct the activities of all the birds and animals.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title112"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“Blue line” activities")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The Adirondack State Park’s final boundaries were drawn in 1922 and on the official maps these areas were enclosed in blue lines. It became common practice when referring to some special regulation to say that these applied because they were “inside the blue line.” On the other hand if the rules did not apply because the area was in some of the privately owned regions intermingled within some of the Park Reservations they were called “outside the Blue.”")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title113"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Blue-noses")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A New England term for the inhabitants of Nova Scotia. It is the name of a potato which the Nova Scotians claim they produce to the greatest perfection and boast is the best in the world. The Americans have therefore countered by calling the producers of this popular item blue-noses.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title114"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("blues")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Shortly after the Civil War a special type of song developed out of the Negro work songs, the hollers and spirituals which became popularized under W. C. Handy about 1912 and have continued to have a great appeal. At first just concerned with vocal effects the blues have spread to instrumental types and been “modified” to such an extent as to include “boogie-woogie” and other jazz forms that seem far removed from the original folk forms but may really represent a growing body of “modern” folk manners. Musically they represent a very special form of syncopation with a slight flatting of the third and seventh intervals of the scale producing the characteristic “blues” notes.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("In the early usage singing the “blues” was a way of indicating one’s despair over one’s lot in life in a way not possible in ordinary speech. This “sorrow” aspect resulted in the reference to the songs as “the po’ man’s heart disease”. Even when the songs became more sophisticated and the center moved north to Chicago it was that same “sorrowful” quality that continued to have appeal.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title115"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Blue-Tail Fly")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("An American Negro minstrel song dating from the 1840’s contains some portions of authentic Negro folksong, especially in the refrain, “Jimmy crack corn and I don’t care”.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title116"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("blutz-wagon")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A farm wagon without any springs. An expression used by the Pennsylvania Dutch and copied by their neighbors.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title117"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bodie, California")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This rough gold mining town had a reputation for being a very unsavory place and much in need of spiritual uplift therefore a minister was assigned the task. Out of this situation came a well-known tale. The minister’s little girl is supposed to have said piteously when she learned of their proposed trip, “Goodbye, God we’re going to Bodie”. Another version has it on the word of the editor of a local paper eager to defend his town’s fair name that what she actually said was, “Good, by God! We’re going to Bodie.”")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title118"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“body masters”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("These were the chapter heads of the widely organized Molly Maguires who planned the executions that the organization felt were necessary, or carried out the destruction of bridges and similar sabotage. They were skillful enough to perform a “clean job”, an undetected one in most cases. However a “Pinkerton man”, an employee of the famed investigation company actually managed to become a trusted member of the body masters and ultimately testified in court about all the actions of this group leading to the final dispersal of the organization.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This Jim McKenna had been a member of the Mollies for two years when he finally accumulated all his information. He had been accepted as “the best Molly of them all”.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title119"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bonanza")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This expression originally meant fair weather at sea. In America it came into common usage in application to the great ore discoveries in the Far West where many a big strike was called a bonanza.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title120"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("boneshaker")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A term used for an early type of bicycle made of wood and very heavy with iron tires and built quite high. The diameter of the front wheel was sometimes three and even four times that of the rear wheel.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title121"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bonnyclabber")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A term for sour milk prevalent in New England but borrowed from the Irish.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title122"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("boogie-woogie")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A style of piano playing. The left hand maintains a heavy repetitive pattern over which the right hand improvises at will. The various patterns are sometimes described as “traveling”, “climbing” or “walking”. Its origin is placed in Chicago where parties were held to help the tenants collect enough contributions to make up the back rent they owed. This type of blues playing reached nationwide popularity about 1936. They say Cou-Cou Davenport gave it its name from “Boogie” the devil, or all the troubles in life.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title123"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bookmaking customs")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Among the bettors on horse races it was customary to refer to a “Dutch book”. That was one in which the bookmaker so arranged the odds on the horses running in a particular race that he lost money. For example he would be paying out $100 to the winners but would have received only $90 in bets placed. A “Round book” was one where the bookmaker just broke even.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title124"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("boomers")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Workers on the Railroad who wandered from job to job either because of incompetency, drunkenness or seasonal rushes. They usually were an independent group, insolent, humorous, worldwise, and given to bragging.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title125"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("boom rats")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A term used for the men who worked on the booms, the accumulated mass of logs, in the early logging days. These very skilled workers either pushed together the felled trees so that they were formed into the booms which made the mass of lumber more manageable, or after their destination had been reached pushed aside the logs marked as belonging to their employers by the brands or stamps they bore. Williamsport on the Susquehanna reached its golden age in those logging days when the boomers fed into the saw mills over three hundred and eighteen million board feet of lumber in one year.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The folk tales of this period claim as evidence of wealth the fact that the ladies of this community had a higher ratio of Paisley shawls than any other community in the nation.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title126"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“boom town” game")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Children in parts of Los Angeles heard so much about the succession of booms in real estate starting with that of 1887 that they played a game patterned after the bogus schemes of the big promoters who laid out a paper town, took in enough money to buy options of a neighboring area and started the cycle all over again—until a bust came along. Then a succession of new arrivals started all over again and the children would rearrange their sandlot plans incorporating into them the many wild plans for dams, highways, race tracks until the whole area should be destroyed as actually happened to many of the grandiose schemes of their elders, leaving mute evidence of these inflated plans in boom hotels in deserted areas, trolley lines running to empty lots and other “debris of a weird civilization left as land marks”—and ready to spring to life when more desire for getting rich quick springs up. In 1889 assessed valuation in the booming AZUSA dropped from that of the year before fourteen million dollars. In an encircling area sixty towns were projected, 77,000 lots sold but only two thousand or so inhabitants attracted.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title127"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("boot, boot camp")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A boot was a new camp especially set up for that purpose in either the Navy, Marine Corps or the Coast Guard.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title128"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Boot Hill")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Name given to a cemetery in Dodge City which set pattern for such names in many Western towns where the unfortunate victims of town violence by the cowboys were buried by the community.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The name comes from the fact that the deceased probably having met an abrupt and turbulent end was speedily buried with his boots on.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title129"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("borderer")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This term is equivalent to the expression “backwoodsman” today. They were the people living on the edge of the frontier, on the border of civilization. All their supplies were carried on their own back. As the fur trade increased, the pack horse was introduced and permanent roads began to be used. This encouraged the arrival of more settlers who began to bring in their families and soon the “borderers” were moving on further West.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title130"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Boston titles")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("In Puritan Boston you might be called MISTER if you had the franchise, that is, owned property which had a value of forty pounds sterling. A common person without the right to vote was called GOODMAN and his wife GOOD-WIFE or in common speech “Goody”. By the revisions in the Charter of 1691 which brought down the qualifications for property ownership in order to vote, the adult male title of MISTER was extended to about one-fifth of the population.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title131"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“boughten bread”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This term was used for baker’s bread in distinction to homemade bread. It implied a definite feeling of disapproval for any poor unfortunate who was forced to eat bread not of the superior quality made at home. In the country districts this attitude lingered long after the city folk bought “Baker’s” bread as a matter of course.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title132"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bowling at pins")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Fact and fancy get easily confused in this field. The Dutch brought it to America as lawn bowling to which Bowling Green in lower Manhattan is a continuing reference. Washington Irving also immortalized reference to the sport by calling attention to the thunder in the Catskills being really the clash of bowling ball on pins.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The popularity of bowling with pins increased greatly after 1835 but soon gamblers became interested so that the game was banned in Connecticut. However as the wording of the measure specifically outlawed bowling at nine pins a new game developed, bowling with ten pins. Out of the need to organize this game the American Bowling Congress arose.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title133"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("box-cars")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("In throwing dice in betting sessions a double six is called a box-car probably because it seems as heavily laden as a freight car.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title134"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Boxer Day")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A day observed in England on December twenty-sixth was observed in and about the state of Michigan by some of the immigrants of English origin. Collection boxes in the churches were opened on that day and sometimes the apprentices went around to their master’s customers for small tips.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title135"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("brakeman on the railroads")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The new brakeman on a train provides the subject for many tales in railroad folklore. The new recruit once called a boll weevil could pull many a boner as was shown in the case where a freight train made a painful trip and finally attained the top of the hill. The engineer heaved a sigh of relief and stated his fear to the brakeman that they might have stalled and rolled down the hill backward out of control. “Nothing to worry about,” the new man told him, “I went back and set all the brakes.” Another subject for tale telling arose in regard to a conductor who was asking a brakeman how it was that he had not seen any fuses burning after they had a slight delay. The brakeman looked surprised and explained he had thrown out several fuses but had not known they were to be lighted.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title136"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“brave man”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("By constant usage there had developed in Northern Pennsylvania an accepted folk definition. “He was not afraid of bears, he had heard Ethan Allen swear.” This referred to the time Allen had attempted to organize some settlers into an independent state and had shouted defiance against the opposition so mightily that the country side claimed they would never hear its equal.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title137"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bread dance")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Many Indian tribes such as the Iroquois and the Shawnee have spring and fall dances that represent a plea for plentiful crops and for good hunting. These were usually participated in by women since the growing and preparation of crops was assumed to be woman’s work.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title138"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bread superstitions")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("It is held by some to bring bad luck if the loaf of bread is cut at both ends; if a piece of bread and butter is dropped on the floor it is considered bad luck in every sense if the buttered side falls to the floor. There are those who are convinced that if a loaf of bread is weighted down with quicksilver it will float along in the water until it stops over the dead body being sought.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title139"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("break a mirror")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Although many believe in the superstition that such an action may bring bad luck, there are others who claim that if one pounds the broken pieces to small bits one may overcome the handicap.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title140"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("break broth")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A savory broth served only at breakfast in colonial days on Cape Cod. All usually ate out of the same bowl.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title141"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“breast stones”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This is a term used for the gravestones of the Moravians in their burial places around Bethlehem, Pennsylvania. Placed presumably upon the chest of the one buried they attempted to show the equality of all in the eyes of the Lord. The dead were buried, not by family, but in most cases by the order in which they died. Little boys were placed in one section, little girls in another. Single men were buried apart from the married men and other related categories were grouped accordingly.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title142"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Brer Rabbit")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Rabbit was the center of the trickster tales common particularly among the Gullah tribes in African folktales and it was not surprising that the transfer was easily made when later, as slaves, they made rabbit stories a large part of their storytelling repertoire. Negro fondness for these tales was probably due to an identification of themselves with the meek and timorous rabbit who yet is able to hold his own against far more powerful animals. Joel Chandler Harris’ versions of the tales of Brer Rabbit are held to be closer to literature than folklore, though his folk art has been so good in many respects that they have retained their original attractiveness in a new setting. On the other hand with the popular development of “Peter Rabbit” of the modern bedtime stories the rabbit has become purely comic and whimsical rather than retaining its original trickster traits.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title143"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("brick making, colonial style")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Bricks were very scarce in America before 1800, most of those used before that time had been brought from England but about that time Philadelphia began to be a leader in the production of bricks and New Jersey a close competitor. Timothy Pickering made recommendations that a single brick at a time be prepared in a mold “shod” with iron. He also suggested that after molding they be thrown into a tub of fine-sifted dust and not into water to prevent their sticking. He thought a proper brick making crew should consist of a man to mold the bricks, another to work the clay, and one to wheel it to the tables, and a boy to bear off one brick at a time. This group he thought could make two thousand bricks a day.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title144"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bridal knots")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This attractive custom was developed in connection with the wedding bouquet in order to hold the good wishes for future happiness.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title145"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bridal Veil Falls")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A popular custom of honeymooning couples visiting Niagara Falls is to throw pennies into the Bridal Veil Falls so as to ensure them good luck during their married life. This idea may have had its origin from the custom of paying “tribute” to the gods of the seas in ancient times.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title146"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“broad horn” boat")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("When a flat boat was propelled by two great oars on either side it was thought to resemble the long-horn cattle of the early West and was given this designation. With a steering oar in the rear to lend resemblance to a tail the appropriateness of the title was felt to be very great.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title147"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("broken striper")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A popular expression used in the Navy to indicate a warrant officer because of the type of stripe worn upon his sleeve.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title148"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bronx cheer")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A custom supposedly originating in that Northern part of New York City were people made a crude and rude noise with their lips to indicate a large degree of disfavor. Also known as giving some one the “raspberry.”")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title149"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Brother Jonathan")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This designation has come to be almost the equivalent of Yankee but there are some who consider it equally applicable to the whole nation as “John Bull” for the British. However there actually was a Brother Jonathan who was the governor of the State of Connecticut at the time of the Revolutionary War. So frequently did General Washington say that certain situations had to be referred to “Brother Jonathan” that the refrain was picked up by others and became associated with the whole section.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title150"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bruder pleger (caretaker)")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Young people of the Moravian sect were very well supervised in all their activities. In Nazareth and the nearby communities of the Pennsylvania Dutch the chaperon of the young men was the bruder pleger and the counterpart for the girls was the Schwester Pleger or matron in charge of single women. They assisted in the arrangements for marriage for these young people who had no opportunity to meet those of the opposite sex. The final choice of a wife was made by lot on the assumption that God would direct the choice. The girl could refuse but so much faith was placed on the divine aspect of the choice that a girl seldom refused the man thus determined for her.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title151"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bruneau John of Idaho")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("John was a member of a local Indian tribe in Idaho though friendly to his white neighbors. He reported to them that his fellow tribesmen were about to attack. However the warning was ignored and the attack was made upon a large freighting outfit on its way to Bruneau. The men were all killed and horribly mutilated. The loyal John was wounded and was thus not forced to take part in the excesses. While destroying all the supplies the Indians came upon a supply of alcohol and all became speedily drunk. John then slipped out of camp and in a wild ride much enlarged upon in the retelling warned all the white people in the Bruneau Valley of the danger in which they were. They safely fled to a neighboring valley. The Indians finally awakened and discovering their prey gone destroyed all the homes instead and then returned to their camp. John was made a scout and won a silver medal for his exploit.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title152"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("brunswick stew")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("As made in North Carolina this popular dish may include practically everything produced on the farm including chicken, beef, veal, squirrels, beans, corn, potatoes, tomatoes, butter beans, vinegar, celery, mustard and plenty of red pepper. Bread should be available for dunking. Such a repast used to be served out-of-doors from a large iron pot by means of a long-handled ladle and placed in a boat-shaped receptacle made of thin wood. An appetizer of bourbon and branch water was popular and a barbecue of roast pig often followed. The Kentuckians call a similar dish burgo (q.v.).")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title153"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("brush fires")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The inhabitants of the Ozark Mountains have developed a wonderful body of folklore. One of the stories they find to their liking has to do with the frequency of brush fires in that neighborhood from September to December. When they finally butcher a hog in the spring they discover he is already smoked.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title154"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("buckaroo")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A term for a cowpuncher West of the Rockies. It was a a corruption of vaquero, a word derived from the Spanish (vaca means cow) which at first was limited in its application to Mexican cowboys.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title155"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bucking board")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("In the early lumber camps of Michigan this term was used to refer to the bulletin board on which would be posted a list of the teamsters working at that time and giving the number of board feet of logs that each had hauled. A reward went to the man with the greatest amount to his credit, usually a fine mackinaw. An illiterate French Canadian was observed studying the list bearing the designated winner. He was peering very closely and seemed very annoyed that he had not won. “Best show me,” he muttered, “that goddam Monsieur Total.”")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title156"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“Buck Private”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A popular expression used in the Air Force as a name for their light, two hundred pound helicopter.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title157"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("buckwheat cakes")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("In colonial New York State buckwheat cakes were already popular and this housewife’s recipe was copied by those who went West also. Stir into your buckwheat flour sour milk or buttermilk and add some yeast left over from the morning’s baking. Put in a big pitcher which is then placed in a pan for after standing in the warm room for several hours the liquid will rise and begin to overflow. It must be “stirred down” frequently to make the best cakes.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title158"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bull")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This popular name for the many portions of rough water found on the Wisconsin River was taken over from the French voyageurs, in whose Canuck style of reference a “bulles” was a rapid. The names they gave are retained in many areas, for example, Grandfather Rapid was “Grand-père bulles.”")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title159"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bulls and bears")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Horace Greeley it is claimed while touring in California near the mother lode of the Sierras witnessed a fierce battle between a bear and a black Mexican bull. He sent a graphic description of this to his New York paper, the Tribune. The account is supposed to have given the Wall Street operators reason for calling the activities of financial rivals by the same terms.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title160"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bull boat (Missouri style)")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This boat borrowed from the Indians was very commonly used on the upper reaches of the Missouri River. A hull resembling an oversize open-work basket was prepared of willow sticks lashed together with strips of green rawhide. As the last step the entire boat was covered with a single buffalo hide of the freshly killed animal. The skin dried taut on the frame some of whose willow shoots were ten feet long and as thick as a wrist, and about eight to ten inches apart, some woven at right angles to one another. The usual weight, about thirty pounds made it possible for the boat to be carried on a squaw’s back; yet it would take a load of over two hundred pounds and several people safely across the river, providing a very essential means of communication.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title161"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Buller legends of Lake Superior")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A Cornishman, Dick Buller was gifted with a fine basso voice by means of which he won all the singing contests of the vocally musical Cornishmen of the Central Mine of the Copper Country. His voice they claimed could penetrate ten levels underground and could be heard ten to fifteen miles away on the surface. Accounts abound of his extraordinary feats.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title162"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“Bullet Barons”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Thus the gangsters of Chicago came to be called in the gang wars of the Prohibition era. Hired assassins were not a new idea for Chicago but these men did things on such an ornate style as to form a colorful part of folklore. Rival gangs were held to be responsible for twenty-five murders a year. A big shot’s funeral was attended by hundreds, many representatives of the city administration attending. One was famous or infamous for his $10,000 silver-trimmed coffin brought from New York in a special baggage car. Truckloads of flowers accompanied the funerals.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title163"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“bull jine”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("From 1731 to the Civil War fire fighting in New York City was done by volunteer companies who took great pride in their work and in their machines. When the apparatus was especially heavy and powerful, it was lovingly designated as a bull engine which became corrupted into the popular term “bull-jine.”")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title164"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bull whacker")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The man needed to whip the mules on the treks to the West was held by those who had an opportunity to listen to him as the most profane of all the Westerners. He would keep the mules going with a great whip twenty feet long and ten inches in circumference at the “belly.” The men became very accurate in the use of the whip. Many bets were made on the ability to cut a coin from the top of a stick.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title165"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bunk fatigue")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("An enlisted man’s expression for those in the Army who are resting or loafing.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title166"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bunny meat (rabbit food)")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A common expression for referring to food or a meal made up of green vegetables, or salads without any real meat.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title167"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bunyan’s animals")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Everything that was associated with Paul Bunyan was gigantic and wonderful; not the least so was a herd of cows which he maintained in his so-called home camp. To the milk which “Boss” gave you only had to add salt and you already had fine butter. That of “Suke” made very wonderful hot cakes. “Baldy’s” never soured and made the finest cream gravy. S’manthy’s milk was pretty poor stuff because she ate so many balsam boughs, but in the winter time it was in great demand as a potent cough medicine.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("In the Bunyan tales they also refer to the gilly grouse which nested near Big Onion River and laid square eggs which Bunyan’s men used for dice. There was an ax handle hound that ate all the ax handles and peavy handles that were left around. Finally there was a shagamaw, a timid creature who wandered the tote roads. He had the claws of a bear on his forefeet and the hoofs of a moose behind. He prowled around devouring coats and mittens which he found on stumps and made a great nuisance of himself.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title168"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("burgo")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A dish particularly associated with Kentucky was made in a variety of ways but there was pretty general agreement that almost anything around the house could be used in this vast stew-meat, corn, celery, turnips and potatoes were basic. Usually just three meats were included, beef, chicken and any animal in season, all cooked down for hours to complete disintegration forming a paste that all Kentucky believes to be the finest possible persuader for political rallies and conventions, and a vitalizer for court days. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("See")]), _vm._v(": B"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("RUNSWICK")]), _vm._v(" S"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TEW")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title169"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bursting horns")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("In the winter of 1886 it was so cold on the plains of the Far West that the horns of the cattle actually burst in some areas. Other conditions were equally bad. An owner of a ranch there asked a cowboy to report on conditions, but the young man found them almost indescribable. Instead he painted a picture for his boss that showed the state of affairs so well that his career as a cow hand was ended, that of Charlie Russell, artist began. His rise to fame started with the poignant scene “Waiting for a Chinook” and grew steadily thereafter.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title170"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("bury the hatchet")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("An expression used in the Northwest and Southwest, borrowed from the Indians, which means the maintenance of friendship because a dangerous weapon has been disposed of.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title171"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Buster Brown")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Having originated what was probably the first comic strip character in the “Yellow Kid” in 1896, Richard Outcault by 1902 had started another famous character whose influence has survived to some extent to the present day. Buster with his dog, Tige, who made penetrating comments on human frailty followed a fairly set pattern in most of his series; the prank for the day, the resolutions, and the comment from Tige. The spread of his fame was so great that practically every other kid was called Buster and he in turn has retained an ageless quality of appeal because of the very universality of childhood that he illustrated.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title172"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("butter-and-egg man")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The title of a play by George S. Kaufman was applied to a group of newly rich men who did not conform to the ordinary designation of “Big Business.” They were making their money by playing the stock market in the period just before the Depression of 1929 and though temporary millionaires were called “big butter-and-egg men” in sarcasm for their rather ostentatious living and lack of refinement by the New York columnists.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title173"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("butter-making")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Many supernatural tales about difficulties with the making of butter center about New England dealing especially with the bewitching of the cream so that the butter will not come. A heated horseshoe dropped into the cream burned out the witch according to one example.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title174"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("butterfly beliefs among the Indians")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The Blackfoot Indians believe that dreams are brought to us in our sleep by butterflies therefore the mother embroiders the sign of the butterfly on a piece of buckskin which she ties on her baby’s head when she wants him to go to sleep.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The Zuni believes when white butterflies are seen warm weather may be expected, but if they fly from the southwest rain should be expected.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title175"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("butterfly beliefs in other parts of the United States")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A butterfly in the house is a wedding sign.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("In Maryland they say if a white butterfly comes into the house and flies around you, you will die, however in Louisiana, they believe it means good luck.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Some believe if a butterfly flies in one’s face it is a sign of cold weather coming; while others specify it must be a yellow butterfly which strikes your face to bring the kind of weather which will turn the leaves yellow in a week.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e610e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780806536927_c02.vue
// module id = 72
// module chunks = 0